import { Dialog, DialogTitle, DialogActions, Button, DialogContent, DialogContentText } from '@mui/material';
import { useTranslation } from 'react-i18next';

type MemberChangeAssociationConfirmProps = {
  associationLabel: string;
  modalOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const MemberChangeAssociationConfirm = (props: MemberChangeAssociationConfirmProps) => {
  const { associationLabel, modalOpen, onClose, onConfirm } = props;
  const { t } = useTranslation(['member']);

  return (
    <Dialog open={modalOpen} onClose={() => onClose()} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
      <DialogTitle id='alert-dialog-title'>{t('member:changeAssociation.confirmTitle', { name: associationLabel })}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {t('member:changeAssociation.confirmDescription', { name: associationLabel })}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ '& .MuiButton-text': { fontWeight: 600 } }}>
        <Button onClick={() => onClose()}>{t('common:button.no')}</Button>
        <Button onClick={() => onConfirm()} variant='contained' color='success' disableElevation autoFocus>
          {t('common:button.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
